export default "/images/linkedin.svg?eee4e92b09232adb0ef349076a61cbc2";